// extracted by mini-css-extract-plugin
export default {"container":"changeLoginPasswort_container__Qw-Ns","form":"changeLoginPasswort_form__F89x2","button":"changeLoginPasswort_button__QeY6M"};